import React from 'react';
import { PopularCities } from '../../../../types';
import TopDestinations from '../TopDestinations';
import './HomeBottomShelfContainer.scss';

export interface HomeBottomShelfContainerProps {
    country_popular_cities?: PopularCities;
    enableTopDestinationsHomepage?: Boolean;
    enablePopularCitiesHomepage?: Boolean;
}

export const HomeBottomShelfContainer: React.FunctionComponent<
    HomeBottomShelfContainerProps
> = (props) => {
    const { enableTopDestinationsHomepage } = props;

    return (
        <div className="bottom-shelf-container">
            {enableTopDestinationsHomepage && <TopDestinations />}
        </div>
    );
};
